// Calendar API
import api, { type AxiosResponse } from './client';
import type { CalendarEvent, AttendeeUser, QueryParams } from './types';

export const calendarAPI = {
  getEvents: (params?: QueryParams): Promise<AxiosResponse<{ count: number; results: CalendarEvent[] }>> =>
    api.get('/calendar/events/', { params }),

  getEvent: (id: number): Promise<AxiosResponse<CalendarEvent>> =>
    api.get(`/calendar/events/${id}/`),

  getUpcoming: (): Promise<AxiosResponse<CalendarEvent[]>> =>
    api.get('/calendar/events/upcoming/'),

  getToday: (): Promise<AxiosResponse<CalendarEvent[]>> =>
    api.get('/calendar/events/today/'),

  createEvent: (data: Partial<CalendarEvent> & { attendee_ids?: number[] }): Promise<AxiosResponse<CalendarEvent>> =>
    api.post('/calendar/events/', data),

  updateEvent: (id: number, data: Partial<CalendarEvent> & { attendee_ids?: number[] }): Promise<AxiosResponse<CalendarEvent>> =>
    api.put(`/calendar/events/${id}/`, data),

  deleteEvent: (id: number): Promise<AxiosResponse<void>> =>
    api.delete(`/calendar/events/${id}/`),

  searchUsers: (params?: { search?: string; company_id?: number }): Promise<AxiosResponse<AttendeeUser[]>> =>
    api.get('/calendar/events/search-users/', { params }),
};
